<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemToSave?.id ? "Modification "+title : "Enregistrement "+title}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">
                <div class="row">
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                    <label>Filiale :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="filiale_id" (change)="load_filiale_data()"
                        [disabled]="true" placeholder="Choisissez " name="filiale_id"
                        id="filiale_id" [multiple]="false" [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsFiliale" [value]="item.id">{{ item?.libelle }}
                        </ng-option>
                    </ng-select>
                </div> -->
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                        style="padding-left: 5px; padding-right: 5px;position: relative;">
                        <label>Garant :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select (change)="onSelectGarant()" [(ngModel)]="itemToSave.garant_id"
                            placeholder="Choisissez " name="garant_id" id="garant_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsGarant" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openAddGarantModal()"><i
                                class="fa fa-plus"></i></button>

                    </div>
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px;position: relative;">
                    <label>Souscripteur :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select (change)="onSelectSouscripteur()" [(ngModel)]="itemToSave.souscripteur_id" placeholder="Choisissez " name="souscripteur_id"
                        id="souscripteur_id" [multiple]="false" [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsSouscripteur" [value]="item.id">{{ item.libelle || (item.nom+' '+item.prenom) }}
                        </ng-option>
                    </ng-select>
        <button class="btn btn-success btn-quick-add" (click)="openAddGarantModal()"><i class="fa fa-plus"></i></button>

                </div> -->

                <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode tarification :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select (change)="onSelectModeTarification()" [(ngModel)]="itemToSave.mode_tarification_id" placeholder="Choisissez "
                            name="mode_tarification_id" id="mode_tarification_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeTarification" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                        style="padding-left: 5px; padding-right: 5px;position: relative;">
                        <label>Police :
                            <!-- ------------{{itemToSave.police_id}} -->
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select (change)="onSelectPolice()" [(ngModel)]="itemToSave.police_id"
                            placeholder="Choisissez " name="police_id" id="police_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsPolice" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openAddPoliceModal()"><i
                                class="fa fa-plus"></i></button>

                    </div>

                    

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                        style="padding-left: 5px; padding-right: 5px;position: relative">

                        <label (click)="openModalDetailBareme()"
                            [ngClass]="{'isSelectedItem':itemToSave.bareme_id}">Barème :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select (change)="onSelectBareme()" [(ngModel)]="itemToSave.bareme_id"
                            placeholder="Choisissez " name="bareme_id" id="bareme_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsBareme" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>

                        <button type="button" class="btn btn-md btn-success"
                            style="border-radius: 50%; position: absolute; top: 0;right: 0;"
                            (click)="openModalAddBareme()">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>


                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux couverture:
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Taux couverture" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_couverture" name="taux_couverture" autocomplete="off"
                            type="text" mask="separator"/>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Plafond:
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Plafond" autocomplete="off"
                            [(ngModel)]="itemToSave.plafond" name="plafond" autocomplete="off"
                            type="text" mask="separator"/>
                    </div>
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                    <label>Code:
                    </label>
                    <input class="form-control custom-input" [disabled]="itemToSave.id" placeholder="Code"
                        autocomplete="off" [(ngModel)]="itemToSave.code" name="code" autocomplete="off"
                        type="text" />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                    <label>Codification:
                        
                    </label>
                    <input class="form-control custom-input" placeholder="Codification" autocomplete="off"
                        [(ngModel)]="itemToSave.codification" name="codification" autocomplete="off" type="text" />
                </div> -->
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Libellé :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                            [(ngModel)]="itemToSave.libelle" name="libelle" autocomplete="off" type="text" />
                    </div>


                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1">
                        <label>Date éffet :
                            <span class="required_champs">*</span>
                        </label>
                        <!-- <input
                                        onkeydown="return false" -->
                        <input type="text" placeholder="Date éffet" autocomplete="off" class="form-control" bsDatepicker
                            [bsConfig]="{
                                          dateInputFormat: 'DD/MM/YYYY',
                                          containerClass: 'theme-dark-blue'
                                        }" [(ngModel)]="itemToSave.date_effet" name="date_effet" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1">
                        <label>Date échéance :
                            <span class="required_champs">*</span>
                        </label>
                        <!-- <input
                                        onkeydown="return false" -->
                        <input type="text" placeholder="Date échéance" autocomplete="off" class="form-control"
                            bsDatepicker [bsConfig]="{
                                          dateInputFormat: 'DD/MM/YYYY',
                                          containerClass: 'theme-dark-blue'
                                        }" [(ngModel)]="itemToSave.date_echeance" name="date_echeance" />
                    </div>





                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Etendu territoire :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.etendu_territoire_id" placeholder="Choisissez "
                            name="etendu_territoire_id" id="etendu_territoire_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsEtenduTerritoire" [value]="item.id">{{ item?.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>


                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Délai de carence (jours) :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Délai de carence" autocomplete="off"
                            [(ngModel)]="itemToSave.delai_carence" name="delai_carence" autocomplete="off" type="text"
                            mask="separator">
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil alerte consommation (%) :
                            <span class="required_champs">*</span>
                        </label>
                        <input mask="separator" class="form-control custom-input" placeholder="Seuil alerte conso" autocomplete="off"
                            [(ngModel)]="itemToSave.seuil_alerte_conso" name="seuil_alerte_conso" autocomplete="off"
                            type="text" />
                    </div>



                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil suspension tiers payant (%) :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Seuil suspension tp" autocomplete="off"
                            [(ngModel)]="itemToSave.seuil_suspension_tiers_payant" name="seuil_suspension_tiers_payant"
                            autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Type remboursement :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select (change)="onSelectTypeRemboursement()" [disabled]="isDetailMode" [(ngModel)]="itemToSave.type_remboursement_id" placeholder="Choisissez "
                            name="type_remboursement_id" id="type_remboursement_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsTypeRemboursement" [value]="item.id">{{ item?.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Taux tpg (%) :
                            <span class="required_champs">*</span>
                        </label>

                        <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Taux tpg" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_tpg" name="taux_tpg" autocomplete="off"
                            type="text" mask="separator" />
                        
                    </div>
                    <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Majoration tpg (%) :
                            <span class="required_champs">*</span>
                        </label>

                        <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Majoration tpg" autocomplete="off"
                            [(ngModel)]="itemToSave.majoration_tpg" name="majoration_tpg" autocomplete="off"
                            type="text" mask="separator" />
                        
                    </div>
                    <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Plafond tpg (%) :
                            <span class="required_champs">*</span>
                        </label>

                        <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Plafond tpg" autocomplete="off"
                            [(ngModel)]="itemToSave.plafond_tpg" name="plafond_tpg" autocomplete="off"
                            type="text" mask="separator" />
                        
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>A qui rembourser? :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.assure_remboursement" placeholder="Choisissez "
                            name="assure_remboursement" id="assure_remboursement" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsRemboursement" [value]="item.code">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                    <label>Mode tarification :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select disabled [(ngModel)]="itemToSave.mode_tarification_id" placeholder="Choisissez "
                        name="mode_tarification_id" id="mode_tarification_id" [multiple]="false"
                        [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsModeTarification" [value]="item.id">{{ item.libelle }}
                        </ng-option>
                    </ng-select>
                </div> -->




                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label (click)="openModalPrestataireReseau()"
                            [ngClass]="{'isSelectedItem':itemToSave.reseau_de_soin_id}">Réseau de soin :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.reseau_de_soin_id" placeholder="Choisissez "
                            name="reseau_de_soin_id" id="reseau_de_soin_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsReseauDeSoin" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>



                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                    <label>Statut :
                        <span class="required_champs">*</span>
                    </label>
                    <ng-select [(ngModel)]="itemToSave.statut_college_id" placeholder="Choisissez "
                        name="statut_college_id" id="statut_college_id" [multiple]="false" [closeOnSelect]="true">
                        <ng-option *ngFor="let item of itemsStatutCollege" [value]="item.id">{{ item.libelle }}
                        </ng-option>
                    </ng-select>
                </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode gestion avenant :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [clearable]="false" [disabled]="isDetailMode"
                            [(ngModel)]="itemToSave.mode_gest_avenant" placeholder="Choisissez "
                            name="mode_gest_avenant" id="mode_gest_avenant" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsListeModeGestAvenant" [value]="item.value">{{
                                item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Périodicité avenant :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [clearable]="false" [disabled]="isDetailMode"
                            [(ngModel)]="itemToSave.periodicite_avenant" placeholder="Choisissez "
                            name="periodicite_avenant" id="periodicite_avenant" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsPeriodiciteAvenant" [value]="item.value">{{ item.libelle
                                }}
                            </ng-option>
                        </ng-select>
                    </div> -->

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label 
                            >Tarif :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.tarif_id" placeholder="Choisissez "
                            name="tarif_id" id="tarif_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsTarif" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_prorata_prime" id="is_prorata_prime" name="is_prorata_prime"
                            autocomplete="off" type="checkbox" />
                        <label for="is_prorata_prime">Prorata prime?
                        </label>

                        <ng-select *ngIf="itemToSave.is_prorata_prime" [(ngModel)]="itemToSave.mode_prorata_id"
                            placeholder="Choisissez mode prorata " name="mode_prorata_id" id="statut_garant_id"
                            [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeProrata" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_attente_prealable_acte_visible"
                            id="is_attente_prealable_acte_visible" name="is_attente_prealable_acte_visible"
                            autocomplete="off" type="checkbox" />
                        <label for="is_attente_prealable_acte_visible">Acte entente préalable visible?
                        </label>


                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_non_garantie_acte_visible" id="is_non_garantie_acte_visible"
                            name="is_non_garantie_acte_visible" autocomplete="off" type="checkbox" />
                        <label for="is_non_garantie_acte_visible">Actes non garantis visibles?
                        </label>


                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_attente_prealable_medoc_visible"
                            id="is_attente_prealable_medoc_visible" name="is_attente_prealable_medoc_visible"
                            autocomplete="off" type="checkbox" />
                        <label for="is_attente_prealable_medoc_visible">Médoc entente préalable visible?
                        </label>


                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_non_garantie_medoc_visible" id="is_non_garantie_medoc_visible"
                            name="is_non_garantie_medoc_visible" autocomplete="off" type="checkbox" />
                        <label for="is_non_garantie_medoc_visible">Médoc non garantie visible?
                        </label>


                    </div> -->


                </div>
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <button type="button" (click)="confirmSaveItem(itemToSave)" class="btn btn-md custom_btn_primary pull-right"
            [class.auth-spinner]="loading" [disabled]="loading">
            Sauvegarder
        </button>

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Annuler
        </button>
    </div>
</div>